/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, April 12th 2022, 6:00:43 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Grid from "@mui/material/Grid";
import { getFieldTypeWidgets } from "form-builder/components/FieldTypeWidgets";
import { FormTagsInfo } from "lib/schemas";
import { ContextTagButton } from "./ContextTagButton";

type FormTagsInfoComponentProps = Pick<FormTagsInfo, "field_tags"> &
  Pick<React.ComponentProps<typeof ContextTagButton>, "onCopyContextTag" | "copiedMessage">;

export const FormTagsInfoComponent = (props: FormTagsInfoComponentProps) => {
  return (
    <Grid container spacing={2} sx={{ padding: 2 }}>
      {props.field_tags?.map((field_tag_description) => {
        const [, iconComponent] = getFieldTypeWidgets(field_tag_description.field_type);
        return (
          <Grid key={`${field_tag_description.field_id}`} item xs={props.field_tags.length > 2 ? 4 : 6}>
            <ContextTagButton
              onCopyContextTag={props.onCopyContextTag}
              copiedMessage={props.copiedMessage}
              tagName={field_tag_description.field_label}
              tag={field_tag_description.field_tag}
              iconComponent={iconComponent}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};
